export const traitNames: Record<string, { name: string; tag: "Common" | "Rare" | "Epic" }> = {
  // Hat
  "Hat #1": { name: "Angel", tag: "Common" },
  "Hat #2": { name: "Fong Antenna", tag: "Common" },
  "Hat #3": { name: "Pink Puffs", tag: "Common" },
  "Hat #4": { name: "Mondalak Hat", tag: "Epic" },

  // Eyes
  "Eyes #1": { name: "Pirate Glasses", tag: "Common" },
  "Eyes #2": { name: "Bored", tag: "Common" },
  "Eyes #3": { name: "Monad Goggles", tag: "Rare" },
  "Eyes #4": { name: "Funky Retro", tag: "Rare" },

  // Mouth
  "Mouth #1": { name: "Witty", tag: "Common" },
  "Mouth #2": { name: "Sucky Ducky", tag: "Epic" },
  "Mouth #3": { name: "Cigar", tag: "Rare" },
  "Mouth #4": { name: "Redbeard", tag: "Epic" },

  // Clothes
  "Clothes #1": { name: "Monad Hoodie", tag: "Common" },
  "Clothes #2": { name: "TownSquare Tshirt", tag: "Common" },
  "Clothes #3": { name: "Monad Jersey", tag: "Rare" },
  "Clothes #4": { name: "Magma Cloak", tag: "Common" },

  // Body
  "Body #1": { name: "OG Fong", tag: "Epic" },

  // BG
  "Background #1": { name: "Orange", tag: "Common" },
  "Background #2": { name: "Purple", tag: "Rare" },
  "Background #3": { name: "Neon", tag: "Epic" },
  "Background #4": { name: "Galaxy", tag: "Rare" },
};
